<template>
  <div class="logistics">
    <div class="logistics_nav">
      <navbar
        title="物流详情"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <van-row>
        <van-col
          span="24"
          class="show_address"
          v-if="delivery_address && delivery_address.consignee"
        >
          <p class="name">
            <img
              class="address"
              src="../../../assets/purchaseSupplier/common/address.png"
            />
            {{ delivery_address.consignee }}
            <span>
              {{ delivery_address.consignee_mobile }}
            </span>
          </p>
          <img
            class="copy"
            src="../../../assets/purchaseSupplier/common/copy.png"
            @click="copyCode(1)"
          />
          <p class="site" ref="copytxt1">
            {{ delivery_address.address_name + delivery_address.address }}
          </p>
        </van-col>
        <van-col span="24" class="post_no">
          {{ post_name }}
          <span ref="copytxt2">{{ post_no }}</span>
          <img
            src="../../../assets/purchaseSupplier/common/copy.png"
            @click="copyCode(2)"
          />
        </van-col>
      </van-row>
      <van-row class="lists" v-show="detailInfo.logistics_info">
        <img src="../../../assets/purchaseSupplier/order/circle_icon.png" />
        <van-col
          span="24"
          v-for="(item, index) in detailInfo.logistics_info"
          :key="index"
          :class="{ first: index == 0 }"
        >
          <p class="address">{{ item.context }}</p>
          <p class="time">{{ item.time }}</p>
          <span class="circle"></span>
          <span v-show="index != listLen" class="line"></span>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
export default {
  components: {
    navbar,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      detailInfo: {},
      delivery_address: {},
      listLen: 0,
      post_name: "",
      post_no: "",
      post_code: "",
    };
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  created() {
    this.delivery_address = JSON.parse(
      localStorage.getItem("delivery_address")
    );
    this.post_name = this.$route.query.name;
    this.post_no = this.$route.query.nu;
    this.post_code = this.$route.query.com;
    this.getLogistic();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getLogistic() {
      let body = {};
      if (this.post_code == "nsf" || this.post_code == "shunfeng") {
        body = {
          com: this.post_code,
          nu: this.post_no,
          phone: this.$route.query.phone.substring(
            this.$route.query.phone.length - 4
          ),
        };
      } else {
        body = {
          com: this.post_code,
          nu: this.post_no,
        };
      }
      this.$api
        .post("/platformsys/member/express/query", body)
        .then((res) => {
          this.detailInfo = res;
          if (res.logistics_info) this.listLen = res.logistics_info.length - 1;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    copyCode(index) {
      const rechage_range = document.createRange();
      if (index == 1) {
        rechage_range.selectNode(this.$refs.copytxt1);
      } else {
        rechage_range.selectNode(this.$refs.copytxt2);
      }
      const rechage_selection = window.getSelection();
      if (rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
      rechage_selection.addRange(rechage_range);
      document.execCommand("Copy");
      this.$toast("复制成功");
      rechage_selection.removeAllRanges();
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.logistics {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .logistics_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #ffffff;
    z-index: 3;
  }

  .box {
    padding: 10rem 0 0;
    box-sizing: border-box;
    height: 100%;
    background: #f5f6f7;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .show_address {
      min-height: 8.3rem;
      padding: 2.2rem 2.4rem 2rem 1.6rem;
      background: #fff;
      margin-bottom: 1.2rem;
      text-align: left;
      position: relative;
      box-sizing: border-box;

      .name {
        color: #333;
        font-size: 1.4rem;
        font-weight: 700;
        height: 2rem;
        line-height: 2rem;
        margin-bottom: 0.4rem;

        .address {
          width: 2rem;
          vertical-align: middle;
          margin-right: 1.2rem;
        }

        span {
          margin-left: 1.2rem;
        }
      }

      .copy {
        width: 2rem;
        position: absolute;
        top: 2.7rem;
        right: 2.4rem;
      }

      .site {
        color: #999;
        font-size: 1.2rem;
        line-height: 1.7rem;
        padding-left: 3.2rem;
      }
    }

    .post_no {
      height: 5.2rem;
      line-height: 5.2rem;
      padding: 0 2.4rem 0 1.6rem;
      color: #333;
      font-size: 1.4rem;
      font-weight: 700;
      background: #fff;

      span {
        margin-left: 1.2rem;
      }

      img {
        width: 2rem;
        float: right;
        margin-top: 1.6rem;
      }
    }

    .lists {
      padding: 1rem 0 1rem 4.3rem;
      margin-top: 0.1rem;
      background: #fff;
      position: relative;

      img {
        width: 1.4rem;
        position: absolute;
        left: 1.6rem;
        top: 2.3rem;
        z-index: 1;
      }

      .van-col {
        min-height: 6.3rem;
        padding-right: 1.6rem;
        border-top: solid 0.05rem #eaeaea;
        position: relative;

        .address {
          color: #666;
          font-size: 1.4rem;
          // height: 2rem;
          line-height: 2rem;
          margin-top: 1rem;
        }

        .time {
          color: #999;
          font-size: 1.2rem;
          height: 1.7rem;
          line-height: 1.7rem;
          margin-top: 0.5rem;
        }

        .circle {
          width: 0.8rem;
          height: 0.8rem;
          border-radius: 0.4rem;
          background: #eaeaea;
          position: absolute;
          top: 1.6rem;
          left: -2.4rem;
        }

        .line {
          width: 0.1rem;
          height: calc(100% - 0.7rem);
          background: #eaeaea;
          position: absolute;
          top: 2.4rem;
          left: -2.05rem;
        }
      }

      .first {
        border-top: none;

        .address {
          color: #666;
          font-size: 1.4rem;
          font-weight: 700;
        }
      }
    }
  }
}
</style>